import React from "react";
import { Divider, Space, Typography, Flex, Row, Col, Grid } from "antd";
import { useNavigate } from "react-router-dom";

import easternerian_logo from "../../assets/easternerian.png";
import facebook_logo from "../../assets/facebook.png";
import instagram_logo from "../../assets/instagram.png";
import whatsapp_logo from "../../assets/whatsapp.png";
import linked_logo from "../../assets/linkedin.png";

const { Text, Link } = Typography;
const { useBreakpoint } = Grid;

const socialIcons = [
    { icon: <img alt="facebook" src={facebook_logo} style={{ height: 32, display: "block" }} />, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61591101207781" },
    { icon: <img alt="whatsapp" src={whatsapp_logo} style={{ height: 32, display: "block" }} />, label: "Instagram", href: "https://instagram.com" },
    { icon: <img alt="linkedin" src={linked_logo} style={{ height: 32, display: "block" }} />,  label: "YouTube",   href: "https://youtube.com"  },
    { icon: <img alt="instagram" src={instagram_logo} style={{ height: 32, display: "block" }} />,        label: "X",         href: "https://x.com"        },
];

const Footer: React.FC = () => {
    const navigate = useNavigate();
    const screens = useBreakpoint();

    const footerLinks = [
        { label: "About us",           onClick: () => navigate("/")        },
        { label: "Cookie Policy",      onClick: () => navigate("/policy")  },
        { label: "Privacy Policy",     onClick: () => navigate("/policy")  },
        { label: "Terms & Conditions", onClick: () => navigate("/policy")  },
        { label: "Popia Notice",       onClick: () => navigate("/policy")  },
        { label: "Sitemap",            onClick: () => navigate("/")        },
    ];

    const sidePadding = screens.xs ? "1.25rem" : screens.md ? "3rem" : "2rem";

    return (
        <footer style={{ background: "#f0ece6", width: "100%", overflowX: "hidden" }}>

            {/* Links + Social */}
            <Row
                justify="space-between"
                align="top"
                gutter={[24, 16]}
                style={{ padding: `1.5rem ${sidePadding}`, margin: 0 }}
            >
                <Col xs={24} sm={16} md={12}>
                    <Row gutter={[16, 12]}>
                        {footerLinks.map((link) => (
                            <Col key={link.label} xs={12} sm={8}>
                                <Link onClick={link.onClick} style={{ cursor: "pointer" }}>
                                    {link.label}
                                </Link>
                            </Col>
                        ))}
                    </Row>
                </Col>

                <Col xs={24} sm={8} md={6}>
                    <Space wrap size="middle" style={{ justifyContent: screens.xs ? "flex-start" : "flex-end", width: "100%" }}>
                        {socialIcons.map((s) => (
                            <Link key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label}>
                                {s.icon}
                            </Link>
                        ))}
                    </Space>
                </Col>
            </Row>

            <Divider style={{ margin: `0 ${sidePadding}`, width: "auto" }} />

            {/* HLG Branding */}
            <Flex
                align="flex-start"
                gap="middle"
                wrap="wrap"
                style={{ padding: `1.25rem ${sidePadding} 1.5rem` }}
            >
                <a href="https://hlgreenwich.co.za" target="_blank" rel="noreferrer">
                    <img src={easternerian_logo} alt="Hlawulani Leonel Greenwich" style={{ height: 40, objectFit: "contain", display: "block" }} />
                </a>

                <Typography.Paragraph style={{ color: "#666", lineHeight: 1.7, margin: 0, maxWidth: 780, flex: "1 1 280px" }}>
                    <Text strong>Delivery Quick Quick</Text> is an online food ordering and delivery marketplace
                    operated as a service of <Text strong>Easternerian (Pty) Ltd</Text>, a company
                    duly registered in accordance with the laws of the Republic of South Africa (Companies Act 71
                    of 2008). Registered office: South Africa. Website:{" "}
                    <Link href="https://easternerian.co.za" target="_blank">easternerian.co.za</Link>.
                    Delivery Quick Quick acts as an intermediary between consumers and food service providers and
                    does not itself prepare or supply food. By using this platform you agree to our Terms &amp;
                    Conditions and acknowledge our POPIA-compliant Privacy Policy. For complaints or queries,
                    please contact us via{" "}
                    <Link href="https://easternerian.co.za" target="_blank">easternerian.co.za</Link>.
                </Typography.Paragraph>
            </Flex>

            {/* Bottom bar */}
            <Flex
                justify="space-between"
                wrap="wrap"
                gap="small"
                style={{ background: "#e8e3dc", padding: `0.9rem ${sidePadding}` }}
            >
                <Text type="secondary">© {new Date().getFullYear()} easternerian (Pty) Ltd · All rights reserved.</Text>
                <Text type="secondary">Delivery Quick Quick is a registered trademark. · South Africa</Text>
            </Flex>

        </footer>
    );
};

export default Footer;